import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FieldSet } from '../../elements';
import DownloadButton from '../DownloadButton';
import BoletoStatus from './BoletoStatus';
import NewBoletoButton from './NewBoletoButton';

const BOLETO_QUERY = gql`
  query Boleto($id: ID!) {
    boleto(id: $id) {
      id
      pdfUrl
      status
      dueDate
      formattedTypableLine
      logs {
        id
        detailedMessage
      }
    }
  }
`;

const StudentBoleto = ({
  id,
  resubmitting,
  onResubmit,
  userCanGenerateBoletos,
  gratuity
}) => {
  const { loading, error, data, refetch } = useQuery(BOLETO_QUERY, {
    variables: { id }
  });
  const boleto = get(data, 'boleto') || {};

  useEffect(() => {
    const interval = setInterval(() => refetch(), 3000);
    return () => clearInterval(interval);
  }, []);

  if (error) {
    if (gratuity) {
      return (
        <>
          <FieldSet title="Boleto" />
        </>
      );
    }
    return (
      <>
        <FieldSet title="Boleto" />
        <p className="red">
          Ocorreu um erro ao carregar o boleto, entre em contato com a
          instituição.
        </p>
      </>
    );
  }
  if (userCanGenerateBoletos && get(boleto, 'status') === 'OVERDUE') {
    return (
      <>
        <FieldSet title="Boleto" />
        <p>Boleto vencido, favor clicar no botão para gerar um novo boleto</p>
        <NewBoletoButton
          disabled={resubmitting}
          onClick={onResubmit}
          avoidCheck
        />
      </>
    );
  }
  return (
    <>
      <FieldSet title="Boleto" />
      <BoletoStatus status={boleto.status} />
      <DownloadButton
        href={boleto.pdfUrl}
        label="Baixar boleto"
        filename="boleto.pdf"
      />
    </>
  );
};

StudentBoleto.propTypes = {
  id: PropTypes.number,
  resubmitting: PropTypes.bool,
  onResubmit: PropTypes.func,
  userCanGenerateBoletos: PropTypes.bool,
  gratuity: PropTypes.shape({
    id: PropTypes.number,
    message: PropTypes.string,
    name: PropTypes.string,
  }),
};

StudentBoleto.defaultProps = {
  id: undefined,
  onResubmit: () => null,
  resubmitting: false,
  userCanGenerateBoletos: false,
  gratuity: null,
};

export default StudentBoleto;
